module.exports = __webpack_public_path__ + "img/md-person.40ab8cab.svg";